// extracted by mini-css-extract-plugin
module.exports = {"promotion-form-table":"promotion-form-table-94b5366e7cc738b96df2db660117b4ea","has-list-add-button":"has-list-add-button-b156394e3a65d85d13661ce9b929783f"};